export var HistoryEvent;
(function (HistoryEvent) {
    /**
     * <zh/> 当命令被撤销时
     *
     * <en/> When the command is undone
     */
    HistoryEvent["UNDO"] = "undo";
    /**
     * <zh/> 当命令被重做时
     *
     * <en/> When the command is redone
     */
    HistoryEvent["REDO"] = "redo";
    /**
     * <zh/> 当命令被取消时
     *
     * <en/> When the command is canceled
     */
    HistoryEvent["CANCEL"] = "cancel";
    /**
     *  <zh/> 当命令被添加到队列时
     *
     *  <en/> When the command is added
     */
    HistoryEvent["ADD"] = "add";
    /**
     * <zh/> 当历史队列被清空时
     *
     *  <en/> When the command queue is cleared
     */
    HistoryEvent["CLEAR"] = "clear";
    /**
     * <zh/> 当历史队列发生变化时
     *
     * <en/> When the command queue changes
     */
    HistoryEvent["CHANGE"] = "change";
})(HistoryEvent || (HistoryEvent = {}));
//# sourceMappingURL=history.js.map